import ArtistEditionForm from './ArtistEditionForm';

export default ArtistEditionForm;
